;
define("products_detail_later_cell.tpl", function(){});

